//
//
//
//
//
//
//
//
//
//

import NavBar from "../components/NavBar.vue";
import Popular from "../components/Popular.vue";
import TweetDetail from "../components/TweetDetail.vue";
import CreateTweets from "../components/CreateTweet.vue";

export default {
  name: "ReplyList",
  components: {
    NavBar,
    Popular,
    TweetDetail,
    CreateTweets,
  },
  data() {
    return {
      // 有時間再優化
      popularUpdate: false,
    };
  },
};
